"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.synchronizeQuantityWithPrice = exports.synchronizePriceWithQuantity = exports.showBuySellSuccessMessage = exports.showBuySellFailMessage = exports.sendOrder = exports.sendFuturesOrder = exports.sellQuantityClicked = exports.sellPriceClicked = exports.placeOrderWithChecks = exports.placeOrder = exports.placeFuturesOrder = exports.clearOrderForm = exports.clearBuySellForm = exports.buyQuantityClicked = exports.buyPriceClicked = void 0;
var _reduxForm = require("redux-form");
var _apiActions = require("./apiActions");
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _placeOrderHelper = require("../../helpers/placeOrderHelper");
var _orderEntryFormConstants = require("../../constants/sendOrder/orderEntryFormConstants");
var _modalActions = require("./modalActions");
var _snackbarActions = require("./snackbarActions");
var _orderFormTypes = require("../../constants/sendOrder/orderFormTypes");
var _orderHelper = require("../../helpers/orderHelper");
var _errorTextFormatter = require("../../helpers/errorTextFormatter");
var _instrumentPositionSelectors = require("../selectors/instrumentPositionSelectors");
var _selectors = require("../margin/selectors");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
var _numberFormatter = require("../../helpers/numberFormatter");
var _level2Selectors = require("../selectors/level2Selectors");
var _futuresSelectors = require("../futures/selectors/futuresSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var placeOrderWithChecks = exports.placeOrderWithChecks = function placeOrderWithChecks(orderFormType, form, formName) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      var _getState, apexCore, level1, instrument, limitPrice, bestOffer, bestBid;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _getState = getState(), apexCore = _getState.apexCore;
            level1 = apexCore.level1, instrument = apexCore.instrument;
            limitPrice = new _bignumber["default"](form.limitPrice);
            if (!(form.orderType === _orderEntryFormConstants.orderTypes.limit.displayName && form.side === _orderEntryFormConstants.buyValue)) {
              _context.n = 1;
              break;
            }
            bestOffer = new _bignumber["default"](level1[instrument.selectedInstrumentId.toString()].BestOffer);
            if (!(limitPrice.gt(bestOffer) && bestOffer.gt(0))) {
              _context.n = 1;
              break;
            }
            return _context.a(2, dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.ORDER_WARNING, {
              side: 'buy',
              orderFormType: orderFormType,
              form: form,
              formName: formName
            })));
          case 1:
            if (!(form.orderType === _orderEntryFormConstants.orderTypes.limit.displayName && form.side === _orderEntryFormConstants.sellValue)) {
              _context.n = 2;
              break;
            }
            bestBid = new _bignumber["default"](level1[instrument.selectedInstrumentId.toString()].BestBid);
            if (!(limitPrice.lt(bestBid) && bestBid.gt(0))) {
              _context.n = 2;
              break;
            }
            return _context.a(2, dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.ORDER_WARNING, {
              side: 'sell',
              orderFormType: orderFormType,
              form: form,
              formName: formName
            })));
          case 2:
            return _context.a(2, dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.CONFIRM_ORDER_REPORT, {
              orderFormType: orderFormType,
              formName: formName
            })));
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var sendOrder = exports.sendOrder = function sendOrder(options) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      var res, errorDetails, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            _context2.n = 1;
            return dispatch((0, _apiActions.callAPI)('SendOrder', options));
          case 1:
            res = _context2.v;
            if (!(res.status === 'Rejected' && res.errormsg === 'Margin_Account_In_Liquidation')) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'sendOrderRejectSnackbar',
              text: 'It is not permissible to place an order while your account is in liquidation. Please try again when your account is no longer in liquidation.',
              type: 'warning'
            })));
          case 2:
            if (!(res.result === false && res.errormsg === 'Invalid_Display_Quantity')) {
              _context2.n = 3;
              break;
            }
            return _context2.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'sendOrderRejectSnackbar',
              text: (0, _errorTextFormatter.formatErrorText)(res),
              type: 'warning'
            })));
          case 3:
            if (!(res.status === 'Rejected' || res.result === false)) {
              _context2.n = 4;
              break;
            }
            errorDetails = (0, _errorTextFormatter.formatErrorText)(res);
            return _context2.a(2, dispatch(
            // t('Your order was rejected. Error: {errorDetails}')
            (0, _snackbarActions.showSnack)({
              id: 'sendOrderRejectSnackbar',
              text: "Your order was rejected. Error: ".concat(errorDetails),
              type: 'warning'
            })));
          case 4:
            return _context2.a(2, res);
          case 5:
            _context2.p = 5;
            _t = _context2.v;
            console.error('sendOrder action error', _t);
          case 6:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 5]]);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var placeOrder = exports.placeOrder = function placeOrder(orderFormType, form) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    useNewForm = _ref3.useNewForm;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, getState) {
      var state, selectedAccountId, _getState2, userInfo, _getState2$apexCore, product, level1, level2, selectedInstrument, priceDecimalPlaces, quantityDecimalPlaces, options, response;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            state = getState();
            selectedAccountId = (0, _selectors.selectedAccountIdSelector)(state);
            _getState2 = getState(), userInfo = _getState2.user.userInfo, _getState2$apexCore = _getState2.apexCore, product = _getState2$apexCore.product, level1 = _getState2$apexCore.level1, level2 = _getState2$apexCore.level2;
            selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(getState());
            priceDecimalPlaces = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement);
            quantityDecimalPlaces = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.QuantityIncrement);
            options = (0, _placeOrderHelper.getFormValuesForSubmittingOrder)(orderFormType, {
              state: getState(),
              decimalPlaces: product.decimalPlaces,
              instrument: {
                selectedInstrumentId: selectedInstrument.InstrumentId
              },
              form: form,
              userInfo: userInfo,
              selectedAccountId: selectedAccountId,
              priceDecimalPlaces: priceDecimalPlaces,
              quantityDecimalPlaces: quantityDecimalPlaces,
              level1: level1,
              level2: level2,
              useNewForm: useNewForm
            });
            if (!(orderFormType === _orderFormTypes.orderFormTypes.block)) {
              _context3.n = 2;
              break;
            }
            _context3.n = 1;
            return dispatch((0, _apiActions.callAPI)('SubmitBlockTrade', options));
          case 1:
            response = _context3.v;
            _context3.n = 4;
            break;
          case 2:
            _context3.n = 3;
            return dispatch(sendOrder(options));
          case 3:
            response = _context3.v;
          case 4:
            return _context3.a(2, response);
        }
      }, _callee3);
    }));
    return function (_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var sendFuturesOrder = exports.sendFuturesOrder = function sendFuturesOrder(options, snackbarOrderType) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var state, selectedInstrument, positionType, instrument, isMarketOrder, res, errorDetails, _errorDetails, _t2;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            _context4.p = 0;
            state = getState();
            selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
            positionType = options.Side === 'Buy' ? 'Long' : 'Short';
            instrument = selectedInstrument.Symbol;
            isMarketOrder = snackbarOrderType === FUTURES_ORDER_TYPES.MARKET;
            _context4.n = 1;
            return dispatch((0, _apiActions.callAPI)('CreateFuturesOrder', options));
          case 1:
            res = _context4.v;
            if (!(isMarketOrder && (res.result === false || res.status === 'Rejected'))) {
              _context4.n = 2;
              break;
            }
            errorDetails = (0, _errorTextFormatter.formatErrorText)(res);
            return _context4.a(2, dispatch(
            // t('There was an error trying to open your {positionType} {instrument} position. Error Details: {errorDetails}')
            (0, _snackbarActions.showSnack)({
              id: 'sendFuturesOrderRejectSnackbar',
              text: "There was an error trying to open your ".concat(positionType, " ").concat(instrument, " position. Error Details: ").concat(errorDetails),
              type: 'warning'
            })));
          case 2:
            if (!(!isMarketOrder && (res.result === false || res.status === 'Rejected'))) {
              _context4.n = 3;
              break;
            }
            _errorDetails = (0, _errorTextFormatter.formatErrorText)(res);
            return _context4.a(2, dispatch(
            // t('There was an error trying to place your {snackbarOrderType} {instrument} order. Error Details: {errorDetails}')
            (0, _snackbarActions.showSnack)({
              id: 'sendFuturesOrderRejectSnackbar',
              text: "There was an error trying to place your ".concat(snackbarOrderType, " ").concat(instrument, " order. Error Details: ").concat(_errorDetails),
              type: 'warning'
            })));
          case 3:
            if (!isMarketOrder) {
              _context4.n = 4;
              break;
            }
            return _context4.a(2, dispatch(
            // t('Your {positionType} {instrument} position was opened successfully.')
            (0, _snackbarActions.showSnack)({
              id: 'sendFuturesOrderSuccessSnackbar',
              text: "Your ".concat(positionType, " ").concat(instrument, " position was opened successfully."),
              type: 'success'
            })));
          case 4:
            if (isMarketOrder) {
              _context4.n = 5;
              break;
            }
            return _context4.a(2, dispatch(
            // t('Your {snackbarOrderType} {instrument} order was placed successfully.')
            (0, _snackbarActions.showSnack)({
              id: 'sendFuturesOrderSuccessSnackbar',
              text: "Your ".concat(snackbarOrderType, " ").concat(instrument, " order was placed successfully."),
              type: 'success'
            })));
          case 5:
            _context4.n = 7;
            break;
          case 6:
            _context4.p = 6;
            _t2 = _context4.v;
            console.error('sendFuturesOrder action error', _t2);
          case 7:
            return _context4.a(2);
        }
      }, _callee4, null, [[0, 6]]);
    }));
    return function (_x6, _x7) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var FUTURES_ORDER_TYPES = {
  MARKET: 'Market',
  LIMIT: 'Limit',
  CONDITIONAL: 'Conditional'
};
var placeFuturesOrder = exports.placeFuturesOrder = function placeFuturesOrder(formValues) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch, getState) {
      var state, selectedInstrument, futuresAccountId, isOrderByQty, quantity, Side, snackbarOrderType, options, response;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            state = getState();
            selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
            futuresAccountId = (0, _futuresSelectors.futuresAccountIdSelector)(state);
            isOrderByQty = formValues.orderByProduct === (selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.Product1Symbol);
            quantity = isOrderByQty ? formValues.quantity : formValues.value;
            Side = formValues.side === '0' ? 'Buy' : 'Sell';
            snackbarOrderType = formValues.orderType; // For snackbar message. Because OrderType can be changed to priceOrderType for conditional orders
            options = {
              InstrumentId: selectedInstrument.InstrumentId,
              AccountId: futuresAccountId,
              OrderType: formValues.orderType,
              Quantity: parseFloat(quantity),
              Side: Side
            };
            if (formValues.orderType === FUTURES_ORDER_TYPES.LIMIT && formValues.limitPrice) {
              options.LimitPrice = parseFloat(formValues.limitPrice);
            }
            if (formValues.orderType === FUTURES_ORDER_TYPES.CONDITIONAL && formValues.priceOrderType === FUTURES_ORDER_TYPES.LIMIT && formValues.price) {
              options.LimitPrice = parseFloat(formValues.price);
            }
            if (formValues.orderType === FUTURES_ORDER_TYPES.CONDITIONAL && formValues.triggerPrice) {
              options.TriggerPrice = parseFloat(formValues.triggerPrice);
              options.OrderType = formValues.priceOrderType;
              options.TriggerBy = formValues.triggerPriceType;
            }
            if (formValues.TPSL && formValues.takeProfit) {
              options.TakeProfitPrice = parseFloat(formValues.takeProfit);
            }
            if (formValues.TPSL && formValues.stopLoss) {
              options.StopLossPrice = parseFloat(formValues.stopLoss);
            }
            if (formValues.orderType === FUTURES_ORDER_TYPES.CONDITIONAL || formValues.orderType === FUTURES_ORDER_TYPES.LIMIT) {
              if (formValues.postOnly) {
                options.PostOnly = true;
              }
            }
            if (formValues.orderType === FUTURES_ORDER_TYPES.MARKET || formValues.orderType === FUTURES_ORDER_TYPES.LIMIT) {
              if (formValues.reduceOnly) {
                options.ReduceOnly = true;
              }
            }
            if ((formValues.orderType === FUTURES_ORDER_TYPES.CONDITIONAL || formValues.orderType === FUTURES_ORDER_TYPES.LIMIT) && formValues.timeInForce) {
              options.TimeInForce = formValues.timeInForce;
            }
            if (formValues.orderType === FUTURES_ORDER_TYPES.CONDITIONAL && formValues.closeOnTrigger) {
              options.CloseOnTrigger = true;
            }
            _context5.n = 1;
            return dispatch(sendFuturesOrder(options, snackbarOrderType));
          case 1:
            response = _context5.v;
            return _context5.a(2, response);
        }
      }, _callee5);
    }));
    return function (_x8, _x9) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var buyPriceClicked = exports.buyPriceClicked = function buyPriceClicked(price) {
  return function (dispatch, getState) {
    var state = getState();
    if (!state.form.orderEntry) return;
    var selectedOrderType = state.form.orderEntry.values.orderType;
    var isStopOrder = selectedOrderType === _orderEntryFormConstants.orderTypes.stopMarket.displayName;
    var _selectedInstrumentSe = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state),
      PriceIncrement = _selectedInstrumentSe.PriceIncrement;
    var convertedPriceIncrement = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(PriceIncrement);
    if (!isStopOrder) {
      dispatch(checkAndSwitchToLimitOrderType());
    }
    dispatch(clearFeeAndTotalAmountValues('orderEntry'));
    dispatch((0, _reduxForm.change)('orderEntry', isStopOrder ? 'stopPrice' : 'limitPrice', (0, _numberFormatter.truncateToDecimals)(parseFloat(price), convertedPriceIncrement)));
  };
};
var buyQuantityClicked = exports.buyQuantityClicked = function buyQuantityClicked(e) {
  return function (dispatch, getState) {
    e.persist();
    var _e$currentTarget$data = e.currentTarget.dataset,
      quantity = _e$currentTarget$data.quantity,
      index = _e$currentTarget$data.index;
    dispatch(clearFeeAndTotalAmountValues('orderEntry'));
    var state = getState();
    var buy = (0, _level2Selectors.level2BuySelector)(state, {
      filterMode: 'selectedInstrumentId'
    });
    var _selectedInstrumentSe2 = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state),
      QuantityIncrement = _selectedInstrumentSe2.QuantityIncrement;
    var convertedQuantityIncrement = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(QuantityIncrement);
    var overallQuantity = calculateQuantity((0, _numberFormatter.truncateToDecimals)(quantity, convertedQuantityIncrement), buy, index);
    dispatch((0, _reduxForm.change)('orderEntry', 'quantity', overallQuantity));
    dispatch((0, _reduxForm.change)('orderEntry', 'side', _orderEntryFormConstants.sellValue));
    dispatch((0, _reduxForm.change)('orderEntry', 'orderType', _orderEntryFormConstants.orderTypes.market.displayName));
  };
};
var sellPriceClicked = exports.sellPriceClicked = function sellPriceClicked(price) {
  return function (dispatch, getState) {
    var state = getState();
    if (!state.form.orderEntry) return;
    var selectedOrderType = state.form.orderEntry.values.orderType;
    var isStopOrder = selectedOrderType === _orderEntryFormConstants.orderTypes.stopMarket.displayName;
    dispatch(clearFeeAndTotalAmountValues('orderEntry'));
    if (!isStopOrder) {
      dispatch(checkAndSwitchToLimitOrderType());
    }
    var _selectedInstrumentSe3 = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state),
      PriceIncrement = _selectedInstrumentSe3.PriceIncrement;
    var convertedPriceIncrement = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(PriceIncrement);
    dispatch((0, _reduxForm.change)('orderEntry', isStopOrder ? 'stopPrice' : 'limitPrice', (0, _numberFormatter.truncateToDecimals)(parseFloat(price), convertedPriceIncrement)));
  };
};
var sellQuantityClicked = exports.sellQuantityClicked = function sellQuantityClicked(e) {
  return function (dispatch, getState) {
    e.persist();
    var _e$currentTarget$data2 = e.currentTarget.dataset,
      quantity = _e$currentTarget$data2.quantity,
      index = _e$currentTarget$data2.index;
    dispatch(clearFeeAndTotalAmountValues('orderEntry'));
    var state = getState();
    var sell = (0, _level2Selectors.level2SellSelector)(state, {
      filterMode: 'selectedInstrumentId'
    });
    var _selectedInstrumentSe4 = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state),
      QuantityIncrement = _selectedInstrumentSe4.QuantityIncrement;
    var convertedQuantityIncrement = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(QuantityIncrement);
    var overallQuantity = calculateQuantity((0, _numberFormatter.truncateToDecimals)(quantity, convertedQuantityIncrement), sell, index, false);
    dispatch((0, _reduxForm.change)('orderEntry', 'quantity', overallQuantity));
    dispatch((0, _reduxForm.change)('orderEntry', 'side', _orderEntryFormConstants.buyValue));
    dispatch((0, _reduxForm.change)('orderEntry', 'orderType', _orderEntryFormConstants.orderTypes.market.displayName));
  };
};
var clearOrderForm = exports.clearOrderForm = function clearOrderForm(formName) {
  return function (dispatch) {
    dispatch(clearFeeAndTotalAmountValues(formName));
    dispatch((0, _reduxForm.reset)(formName));
  };
};
var clearBuySellForm = exports.clearBuySellForm = function clearBuySellForm(formName) {
  return function (dispatch) {
    var form = formName || 'buySell';
    dispatch(clearField(form, 'quantity', ''));
    dispatch(clearField(form, 'price', ''));
    dispatch(clearField(form, 'amountRadio', 'custom'));
    dispatch(clearField(form, 'limitPrice', ''));
    dispatch(clearField(form, 'fee', '0'));
    dispatch(clearField(form, 'responseMessage', ''));
  };
};
var showBuySellSuccessMessage = exports.showBuySellSuccessMessage = function showBuySellSuccessMessage() {
  return function (dispatch) {
    // t('Your order was filled successfully!')
    dispatch((0, _reduxForm.change)('buySell', 'responseMessage', 'Your order was filled successfully!'));
  };
};
var showBuySellFailMessage = exports.showBuySellFailMessage = function showBuySellFailMessage() {
  return function (dispatch) {
    // t('Your order failed, please try again')
    dispatch((0, _reduxForm.change)('buySell', 'responseMessage', 'Your order failed, please try again'));
  };
};
var synchronizeQuantityWithPrice = exports.synchronizeQuantityWithPrice = function synchronizeQuantityWithPrice(price, form, field, formObj) {
  return function (dispatch, getState) {
    var _getState3 = getState(),
      _getState3$apexCore = _getState3.apexCore,
      level2 = _getState3$apexCore.level2,
      decimalPlaces = _getState3$apexCore.product.decimalPlaces;
    var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(getState());
    var quantity = (0, _orderHelper.syncQuantityWithPrice)(price, {
      level2: level2,
      selectedInstrument: selectedInstrument,
      side: formObj.values.side,
      decimalPlaces: decimalPlaces
    });
    dispatch((0, _reduxForm.change)(form, field, quantity));
  };
};
var synchronizePriceWithQuantity = exports.synchronizePriceWithQuantity = function synchronizePriceWithQuantity(quantity, form, field, formObj) {
  return function (dispatch, getState) {
    var _getState4 = getState(),
      _getState4$apexCore = _getState4.apexCore,
      level2 = _getState4$apexCore.level2,
      decimalPlaces = _getState4$apexCore.product.decimalPlaces;
    var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(getState());
    var price = (0, _orderHelper.syncPriceWithQuantity)(quantity, {
      level2: level2,
      selectedInstrument: selectedInstrument,
      side: formObj.values.side,
      decimalPlaces: decimalPlaces
    });
    dispatch((0, _reduxForm.change)(form, field, price));
  };
};
var calculateQuantity = function calculateQuantity(initValue, orders, quantityIndex) {
  var buy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var init = new _bignumber["default"](initValue);
  var quantity = orders.filter(function (data, index) {
    return buy ? index < quantityIndex : index > quantityIndex;
  }).reduce(function (prev, current) {
    return prev.plus(current.Quantity);
  }, init);
  return quantity.toString();
};

/**
 * Switch order type to 'Limit' if 'Market' is selected before
 */
var checkAndSwitchToLimitOrderType = function checkAndSwitchToLimitOrderType() {
  return function (dispatch, getState) {
    var selectedOrderType = getState().form.orderEntry.values.orderType;
    if (selectedOrderType === _orderEntryFormConstants.orderTypes.market.displayName) {
      dispatch((0, _reduxForm.change)('orderEntry', 'orderType', _orderEntryFormConstants.orderTypes.limit.displayName));
    }
  };
};
var clearFeeAndTotalAmountValues = function clearFeeAndTotalAmountValues(form) {
  return function (dispatch) {
    dispatch(clearField(form, 'fee', '0'));
    dispatch(clearField(form, 'totalAmount', '0'));
  };
};
var clearField = function clearField(form, field, initialValue) {
  return function (dispatch) {
    dispatch((0, _reduxForm.change)(form, field, initialValue));
    dispatch((0, _reduxForm.untouch)(form, field));
  };
};